import React from 'react';
import { motion } from 'framer-motion';
import { CountdownTimer } from './CountdownTimer';
export function Urgencia() {
  return <section className="bg-[#0C1220] py-[60px] md:py-[80px]" data-id="element-257">
      <div className="max-w-[600px] mx-auto px-5 text-center" data-id="element-258">
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} className="bg-navy-2 border border-[#FF5F57]/30 rounded-2xl p-8 shadow-[0_0_40px_rgba(255,95,87,0.1)]" data-id="element-259">
          <p className="text-[12px] font-black tracking-[2px] text-[#FF5F57] uppercase mb-4" data-id="element-260">
            ⏰ PRECIO DE LANZAMIENTO — CIERRA EN:
          </p>

          <CountdownTimer data-id="element-261" />

          <p className="text-[15px] font-bold text-brand-gold mt-4 mb-8" data-id="element-262">
            ⚠️ Después sube $8.000 ARS. No vuelve.
          </p>

          <div className="bg-navy-3 rounded-xl p-5 border border-brand-blue-dark" data-id="element-263">
            <p className="text-[14px] font-bold text-white mb-3 flex items-center justify-center gap-2" data-id="element-264">
              <span className="text-[#FF5F57]" data-id="element-265">🔴</span> Cupos al precio de
              lanzamiento
            </p>
            <p className="text-[13px] text-brand-gray mb-3" data-id="element-266">Quedan pocos</p>

            <div className="w-full h-3 bg-navy-2 rounded-full overflow-hidden border border-brand-blue-dark mb-2" data-id="element-267">
              <motion.div initial={{
              width: 0
            }} whileInView={{
              width: '68%'
            }} viewport={{
              once: true
            }} transition={{
              duration: 1,
              delay: 0.2
            }} className="h-full bg-brand-gold rounded-full" data-id="element-268" />
            </div>
            <p className="text-[12px] text-brand-gray font-medium" data-id="element-269">
              68% de los cupos ya tomados
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}